import React from 'react';

/**
 * Sparkline — pure-SVG mini bar chart for 12 monthly values. Designed to sit
 * inline inside a table row in İşletmeler.
 *
 * Props:
 *   months: number[12]            — TRY totals per month (Jan..Dec)
 *   width, height                 — SVG dimensions (px)
 *   color                         — bar fill (defaults to purple-500)
 *
 * Empty months render as a barely-visible gray track so the user can see the
 * bar count without confusing a flat zero series for "no data". The hover
 * title shows the Türkçe month name + formatted TRY total.
 */
const TR_MONTHS = ['Oca','Şub','Mar','Nis','May','Haz','Tem','Ağu','Eyl','Eki','Kas','Ara'];

const fmtTRY = (n) =>
  new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 0 }).format(Number(n || 0));

const Sparkline = ({ months = [], width = 110, height = 28, color = '#a855f7' }) => {
  const safe = Array.isArray(months) && months.length === 12
    ? months.map((v) => Number(v) || 0)
    : new Array(12).fill(0);
  const peak = Math.max(...safe, 0);
  const barW = width / 12;
  const gap = 1.5;
  const innerW = barW - gap;
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      aria-label="Aylık harcama trendi"
      data-testid="supplier-sparkline"
    >
      {safe.map((v, i) => {
        const h = peak > 0 ? Math.max(1, (v / peak) * (height - 2)) : 1;
        const x = i * barW + gap / 2;
        const y = height - h;
        const isEmpty = v === 0;
        return (
          <g key={i}>
            <rect
              x={x}
              y={y}
              width={innerW}
              height={h}
              fill={isEmpty ? '#e5e7eb' : color}
              rx="1"
            >
              <title>{`${TR_MONTHS[i]}: ${fmtTRY(v)}`}</title>
            </rect>
          </g>
        );
      })}
    </svg>
  );
};

export default Sparkline;
